import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { SessionService } from '../session/session.service';

@Injectable()
export class FileService {
  constructor(
    protected http: HttpClient,
    protected sessionService: SessionService,
    @Inject('API_URL') private readonly apiUrl: string) {
  }

  public getFile(instance: string, fileId: string): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(`${this.apiUrl}${instance}/fil/${fileId}/get`, { responseType: 'arraybuffer', observe: 'response' });
  }
  
  public getFileFromGk(requestId: string, fileId: string, fileName: string): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(`${this.apiUrl}InformationRequest/GetFile/${requestId}/${fileId}/fileName`, { responseType: 'arraybuffer', observe: 'response' });
  }

  public getFileUrl(instance: string, fileId: string): string {
    return `${this.apiUrl}${instance}/fil/${fileId}/get?token=${this.sessionService.getToken()}`;
  }
}
